/**
 * Opdaterer bundle-count i header ud fra cart state
 */
function updateHeaderBundleCountFromCart(cart) {
  if (!cart || !cart.items) return;

  let totalBundles = 0;

  cart.items.forEach((item) => {
    const bundleSize = parseInt(item.properties?.bundle_size, 10) || 1;

    if (bundleSize > 1) {
      totalBundles += Math.floor(item.quantity / bundleSize);
    } else {
      totalBundles += item.quantity;
    }
  });

  const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
  if (!bubble) return;

  const visible = bubble.querySelector('span[aria-hidden="true"]');
  if (visible) visible.textContent = totalBundles;

const sr = bubble.querySelector('.visually-hidden');
if (sr) {
  const s = window.customStrings || { bundle: 'bundt', bundles: 'bundter', pcs: 'stk' };
  const bundleWord = totalBundles === 1 ? s.bundle : s.bundles;

  sr.textContent = `${totalBundles} ${bundleWord}`;
}
}

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
      closeButton.addEventListener('click', this.close.bind(this));
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);
      if (!container) return;

      container.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    // ✅ OPDATER HEADER BUNDLE COUNT DIREKTE FRA CART STATE
    updateHeaderBundleCountFromCart(parsedState);

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const el = parsed.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
